<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'CPD'
}

</script>



// WEBPACK FOOTER //
// src/Adm/CPD/containers/CPD.vue